import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';

import {
    __experimentalInputControl as InputControl,
    __experimentalGrid as Grid,
    SelectControl,
    Button,
    Snackbar,
    TabPanel
} from '@wordpress/components';


const TabAdvanced = ( props ) => {
		// General
		const [ saving, setSaving ] = useState( false );
		const [ onSaveMessage, setOnSaveMessage ] = useState( '' );
		const [ loading, setLoading ] = useState( false );

		// Advanced
		const [ timeInterval, setTimeInterval ] = useState( re_esp_settings.timeInterval );
		const [ requestNumber, setRequestNumber ] = useState( re_esp_settings.requestNumber );


		const saveSettings = () => {
			setSaving( true );
			setOnSaveMessage( '' );
			setLoading( true );

			apiFetch( {
				path: '/re/esp/v1/save_advanced_settings',
				method: 'POST',
				data: {
					timeInterval,
					requestNumber,
				},
			} ).then( ( response ) => {
				setOnSaveMessage( response.message );
				setSaving( false );
				setLoading( false );
			} );

		}

	return (
		<Grid columns={ 1 }>
				{ onSaveMessage && (
				<Snackbar
					className="re-esp-snackbar re-esp-snackbar-settings"
					explicitDismiss
					onDismiss={ () => setOnSaveMessage( '' ) }
					status="success"
				>
					{ onSaveMessage }
				</Snackbar>
			) }

			<InputControl
				type="number"
				label={ __( 'Time interval (seconds)', 're-ESP' ) }
				value={ timeInterval }
				onChange={ ( value ) => setTimeInterval( value ) }
				min={ 1 }
				help={ __( 'The time interval in seconds between each queue processing.', 're-ESP' ) }
			/>

			<InputControl
				type="number"
				label={ __( 'Request number', 're-ESP' ) }
				value={ requestNumber }
				onChange={ ( value ) => setRequestNumber( value ) }
				min={ 1 }
				help={ __( 'The number of requests to be processed in each queue processing.', 're-ESP' ) }
			/>

			<Button
				className="button button-primary re-esp-primary-button"
				style={ { marginTop: '1em' } }
				isBusy={ saving }
				onClick={ saveSettings }
				disabled={ loading || saving || ! timeInterval }
			>
				{ __( 'Save', 're-ESP' ) }
			</Button>
		</Grid>
	)
}

export default TabAdvanced;